<template>
  <div class="input-container">
    <div class="label" v-text="label"></div>
    <div style="position: relative;">
      <input ref="input" v-model.trim="input" />

      <span v-if="type === 'verifiCode'" class="verifi-code" @click="getVerifiCode" v-text="countDownText"></span>
    </div>
    <Verify ref="verify" class="posVer" />
  </div>
</template>

<script>
// import { getVerificationCode } from "@/api/user.js";
import { getVerityCode } from "@/api/channel";
import Verify from "@/components/verify.vue";

export default {
  components: {
    Verify
  },
  props: ["value", "label", "type", "phone", "apiName"],
  data() {
    return {
      // 显示输入框
      showInput: false,
      // 输入内容
      input: "",
      // 验证码倒计时
      countDown: null,
      // 是否显示倒计时
      showCountDown: false,
      // 倒计时定时器
      timer: null
    };
  },
  created() {
    this.input = this.value;
    if (this.input) {
      this.showInput = true;
    }
  },
  methods: {
    // 获取验证码方法
    async getVerifiCode() {
      if (!!this.countDown && this.countDown > 0) {
        return;
      }

      if (!this.phone) {
        this.$message({
          type: "error",
          duration: 1000,
          message: "请输入手机号"
        });
        return;
      }

      let phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!phoneReg.test(this.phone)) {
        this.$message({
          type: "error",
          duration: 1000,
          message: "请输入正确的手机号"
        });
        return;
      }

      this.$refs.verify.showCaptcha().then(res => {
        var params = {
          login_name: this.phone,
          type: "0",
          source: "yc_magazine_ofl",
          ...res
        };
        try {
          getVerityCode(params).then(res => {
            if (res.returncode !== "0000") {
              this.$message({
                type: "error",
                duration: 1000,
                message: res.returnmsg
              });
              return;
            }
            this.$message({
              type: "success",
              duration: 1000,
              message: "发送成功,请注意查看手机"
            });
            this.$refs.verify.destroy();
            this.countDown = 60;
            this.showCountDown = true;
            this.timer = setInterval(() => {
              if (this.countDown === 1) {
                clearInterval(this.timer);
                this.showCountDown = false;
                this.countDown = null;
              }
              this.countDown -= 1;
            }, 1000);
          }).catch(res => {
            this.showError(res);
          });
        } catch (error) {
          this.showError(error);
        }
      })
    },
    inputFocus() {
      this.showInput = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    showError(msg) {
      this.$message({
        type: "error",
        message: msg
      });
    }
  },
  computed: {
    countDownText() {
      if (this.showCountDown) {
        return `${this.countDown}s`;
      } else {
        return "获取验证码";
      }
    }
  },
  watch: {
    input(newVal) {
      this.$emit("change", newVal);
    }
  },
  model: {
    prop: "value",
    event: "change"
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  height: 84px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  border-bottom: 1px solid #eee;
  padding: 12px 0;
  box-sizing: border-box;

  .verifi-code {
    position: absolute;
    top: 50%;
    right: 0;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #009bfa;
    transform: translate(0, -50%);
    cursor: pointer;
  }

  .label {
    width: 100%;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #afafaf;
    margin-bottom: 0.08rem;
  }

  input {
    width: 100%;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #323232;
    border: none;
    outline: none;
  }

  .placeholder {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #afafaf;
  }

  .posVer {
    position: absolute;
    top: 260px;
    width: 284px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/channel/components/Input.vue